class KlaviyoForm extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleSubmit = this.handleSubmit.bind(this)

    this.listeners.add(this.els.form.element, 'submit', this.handleSubmit)
  }

  async handleSubmit (event) {
    event.preventDefault()

    const customerEmail = this.els.email?.element?.value
    if (!customerEmail) return

    const countryCode = window.localStorage.getItem('PP-BAO-localization')
    const latestStorefront = window.theme.latestStorefront

    let listId = this.listId

    // Country-specific list ID overrides.
    const customerCountry = this.dataset?.country || null
    if (customerCountry) {
      switch (customerCountry) {
        case 'Germany':
          listId = 'SF5ivA'
          break
        case 'South Korea':
          listId = 'TvmRXw'
          break
      }
    }

    try {
      const subscriptionAttributes = {
        profile: {
          data: {
            type: 'profile',
            attributes: {
              email: customerEmail,
              subscriptions: {
                email: {
                  marketing: {
                    consent: 'SUBSCRIBED',
                  },
                },
              },
            },
          },
        },
      }

      if (countryCode || latestStorefront) {
        subscriptionAttributes.profile.data.attributes.properties = {}

        if (countryCode) {
          subscriptionAttributes.profile.data.attributes.properties.CountryCode = countryCode
        }

        if (latestStorefront) {
          subscriptionAttributes.profile.data.attributes.properties['Latest StoreName'] = latestStorefront
        }
      }

      if (customerCountry) {
        subscriptionAttributes.profile.data.attributes.location = {
          country: customerCountry,
        }
      }

      // Add custom_source at subscription level if provided
      if (this.customSource) {
        subscriptionAttributes.custom_source = this.customSource
      }

      const bodyData = {
        data: {
          type: 'subscription',
          attributes: subscriptionAttributes,
          relationships: {
            list: {
              data: {
                type: 'list',
                id: listId,
              },
            },
          },
        },
      }

      const options = {
        method: 'POST',
        headers: {
          accept: 'application/vnd.api+json',
          revision: window.theme.klaviyo.apiVersion,
          'content-type': 'application/vnd.api+json',
        },
        body: JSON.stringify(bodyData),
      }

      const response = await fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${window.theme.klaviyo.apiKey}`,
        options,
      )

      if (response.ok) {
        this.els.form.element.setAttribute('aria-hidden', true)
        this.els.submitted.element.setAttribute('aria-hidden', false)

        window.BAO.dispatchEvent(window.BAO.EVENTS.KLAVIYO.FORM_SUBMITTED, {
          customerEmail,
        })
      } else {
        throw new Error(`API returned ${response.status}`)
      }
    } catch (error) {
      console.error('Klaviyo subscription error:', error)
      // TODO: Show error message to user if error element exists
      // if (this.els.error?.exists) {
      //   this.els.error.element.setAttribute('aria-hidden', false)
      // }
    }
  }

  get listId () {
    return this.dataset.listId || window.theme.klaviyo.newsletterListId
  }

  get customSource () {
    return this.dataset.customSource || null
  }
}

if (!customElements.get('klaviyo-form')) {
  customElements.define('klaviyo-form', KlaviyoForm)
}
